import * as types from '../actions/types';
import * as settings from '../settings';

const initialState = {
  center: {
    longitude: settings.DEFAULT_LONGITUDE,
    latitude: settings.DEFAULT_LATITUDE,
  },
  tracker: null,
  reports: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_TRACKER:
      return {
        ...state,
        tracker: action.tracker,
      };

    case types.UPDATE_REPORTS:
      return {
        ...state,
        reports: action.reports,
      };

    case types.CHANGE_MAP_CENTER:
      return {
        ...state,
        center: {
          longitude: action.longitude,
          latitude: action.latitude,
        },
      };

    default:
      return state;
  }
};

export default reducer;
